<template>
  <div class="edit-button">
    <b-dropdown v-if="editOptions.length > 1" class="dropdown-add" aria-role="list" :position="position">
      <button
        class="button add"
        :class="{ danger: danger, gray: isGray }"
        slot="trigger"
        slot-scope="{ active }"
        :disabled="disabled"
      >
        <slot>
          <span class="text">{{ $t('button.add.new') }}</span>
        </slot>
        <b-icon :icon="active ? 'sort-up' : 'sort-down'" />
      </button>
      <slot name="edit-actions" />
    </b-dropdown>
    <div v-else-if="editOptions.length" class="dropdown dropdown-add no-actions">
      <button class="button add" :class="{ danger: danger, gray: isGray }" @click="$emit('click')" :disabled="disabled">
        <slot>
          <span class="text">{{ $t('button.add.new') }}</span>
        </slot>
      </button>
      <slot name="description" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    editOptions: {
      type: Array,
      default() {
        return []
      }
    },
    position: {
      type: String,
      default: 'is-bottom-left'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    isGray: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.edit-button {
  .dropdown {
    &.no-actions {
      .button {
        padding-right: 0.625rem;
        padding-left: 0.625rem;
      }
    }
    .button {
      padding: 0rem;
      padding-right: 0.625rem;
      height: 1.25rem;
      &.add {
        color: white;
        background: #4bbd4d;
        border-color: #4bbd4d;
        font-weight: bold;
        &.danger {
          color: #fc4850;
          background: white;
          border-color: #fc4850;
          font-weight: bold;
        }
        &.gray {
          color: #818181;
          background: white;
          border-color: #818181;
          font-weight: bold;
        }
      }
      .text {
        padding-right: 0.625rem;
        padding-left: 0.625rem;
      }
      .icon {
        height: 1rem;
        border-bottom-right-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
        border-left: 1px solid #ccc;
        .fa-sort-down {
          padding-bottom: 0.625rem;
        }
        .fa-sort-up {
          padding-top: 0.625rem;
        }
      }
    }
    .dropdown-menu {
      padding-top: 0.625rem;
    }
  }
}
</style>
